<template>
  <div class="container">
    <div class="header">
      <h2 class="title cr-fs-lg">软件著作权登记</h2>
      <router-link to="/businessCenter/caseManage">案件列表>></router-link>
    </div>

    <div class="material cr-fs-md">材料： <a :href="link" target="_blank">《软件著作权登记服务协议》</a></div>

    <div class="card-info cr-fs-md">
      <div class="head">
        <div class="head-left">
          <span>案件号：</span>
          <cr-tooltip placement="topLeft" title="点击复制">
            <span v-copy="caseDetail.caseNo" @click="copySuccess">{{ caseDetail.caseNo }}</span>
          </cr-tooltip>
          <span class="time">（{{ caseDetail.createdAt }}）</span>
        </div>
        <div class="head-right">
          <span>联系人： </span>
          <cr-tooltip placement="topLeft" title="点击复制">
            <span v-copy="caseDetail.userName" @click="copySuccess">{{ caseDetail.userName }}-</span>
            <span v-copy="caseDetail.userPhone" @click="copySuccess">{{ caseDetail.userPhone }}</span>
          </cr-tooltip>
        </div>
      </div>
      <div class="content">
        <div class="left">
          <p class="cr-text-black-1">{{ formData.fullName.data || '' }}</p>
          <p>
            {{ caseDetail.coprType == 1 ? '软件著作权' : '' }} <span class="cr-text-grey-1" v-show="caseDetail.processType || caseDetail.processCycle">（{{ caseDetail.processType == 1 ? '移动App在线登记' : '计算机软件著作权登记' }} {{ caseDetail.processCycle }}）</span>
          </p>
          <p class="tip">
            {{ getChildState(caseDetail.childState) }}
          </p>
          <p>
            <span class="cr-text-black-1 cr-mr-1" style="font-weight: bold">¥ {{ (caseDetail.amount / 100).toFixed(2) }}</span>
            <span class="moneyState warn" v-if="caseDetail.transState === 0">待付款</span>
            <span class="moneyState" v-if="caseDetail.transState === 1">已付款</span>
            <span class="moneyState" v-if="caseDetail.transState === -1">待退款</span>
            <span class="moneyState" v-if="caseDetail.transState === -2">已退款</span>
            <span class="cr-text-aa" v-show="caseDetail.payTime || caseDetail.paidMethod">（{{ caseDetail.payTime }} {{ getPaidMethod(caseDetail.paidMethod) }}）</span>
          </p>
        </div>
        <div class="right">
          <div class="cr-ai-center cr-mb-2">
            <div class="item" v-for="(over, index) in caseDetail.stateLogs" :key="index" :class="{ active: index + 1 === caseDetail.state }">{{ over.state }}{{ over.startingDate }}</div>
          </div>
          <div class="fun-list">
            <div class="fun-item" v-for="(item, index) in caseDetail.optLogInfos" :key="index">
              <span class="dot" />
              <span class="time">{{ item.date }}</span>
              <span class="desc">{{ item.content }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <base-form :formData.sync="formData" @onSubmit="onSubmit" @saveCase="saveCase" @onShare="onShare" @onFocus="onFocus" @onBlur="onBlur" @onDataChange="onDataChange" @onPay="onPay" @enable="enable" :token="token" :transState="caseDetail.transState" />

    <a-modal v-model="saveCaseModal" @ok="onSubmit" @cancel="saveCaseModal = false" width="440px" cancelText="稍后提交" okText="立即提交">
      <p class="cr-mt-2">案件信息已保存，您的材料信息已齐全，是否提交平台审核？</p>
    </a-modal>

    <a-modal v-model="shareModal" width="460px" title="链接已复制" :footer="null">
      <div class="share-modal-content">
        <p class="case-no">案件号：{{ caseNo }}</p>
        <p class="case-desc">版权登记链接已复制，您可以直接分享给客户。</p>
        <div class="case-url">
          <div class="url cr-fs-ellipsis">{{ shareUrl }}</div>
          <a-button type="primary" v-copy="shareUrl" class="btn" @click="copySuccess">复制链接</a-button>
        </div>
        <div class="footer">
          <a-button type="primary" ghost @click="shareModal = false">好的，知道了</a-button>
        </div>
      </div>
    </a-modal>

    <cr-loading :loading="loading"></cr-loading>
  </div>
</template>

<script>
import io from 'socket.io-client'
import { randomString } from '@/utils'
import BaseForm from './component/baseForm.vue'
import { caseOverview, saveCase, submitCase } from '@/api/caseDetail'
import { message } from 'ant-design-vue'
import { sendPay } from '@/api/common'
let socket = null
export default {
  name: 'CaseDetail',
  data() {
    return {
      formData: {
        fullName: { data: '', enableAt: '0', focusUser: '' },
        shortName: { data: '', enableAt: '0', focusUser: '' },
        versionNo: { data: '', enableAt: '0', focusUser: '' },
        category: { data: '', enableAt: '0', focusUser: '' },
        completionDate: { data: '', enableAt: '0', focusUser: '' }, // 开发完成日期
        publishState: { data: '', enableAt: '0', focusUser: '' }, // 发布状态
        firstPublishDate: { data: '', enableAt: '0', focusUser: '' }, // 首次发表日期
        firstPublishAddress: { data: '', enableAt: '0', focusUser: '' }, // 首次发表地址
        developHardware: { data: '', enableAt: '0', focusUser: '' }, // 开发环境
        productHardware: { data: '', enableAt: '0', focusUser: '' }, // 运行硬件环境
        developOs: { data: '', enableAt: '0', focusUser: '' }, // 开发操作系统
        developTools: { data: '', enableAt: '0', focusUser: '' }, // 软件开发环境
        operatingPlatform: { data: '', enableAt: '0', focusUser: '' }, // 软件运行平台
        supportingEnv: { data: '', enableAt: '0', focusUser: '' }, // 软件支撑环境
        programmingLanguage: { data: '', enableAt: '0', focusUser: '' }, // 编程语言
        sourceCodeCount: { data: '', enableAt: '0', focusUser: '' }, // 源程序量
        developPurpose: { data: '', enableAt: '0', focusUser: '' }, // 开发目的
        fieldOriented: { data: '', enableAt: '0', focusUser: '' }, // 面向领域
        attributes: { data: '', enableAt: '0', focusUser: '' }, // 软件属性
        primaryFunction: { data: '', enableAt: '0', focusUser: '' }, // 主要功能
        technicalFeature: { data: '', enableAt: '0', focusUser: '' }, // 技术特点
        authors: { data: '', enableAt: '0', focusUser: '' }, // 著作权人信息
        contactPerson: { data: '', enableAt: '0', focusUser: '' }, // 联系人信息
        postalAddress: { data: '', enableAt: '0', focusUser: '' }, // 邮寄地址
        postalAddressPrecise: { data: '', enableAt: '0', focusUser: '' }, // 邮寄详细地址
        postalCode: { data: '', enableAt: '0', focusUser: '' }, // 邮政编码
        contactPhone: { data: '', enableAt: '0', focusUser: '' }, // 联系电话
        contactEmail: { data: '', enableAt: '0', focusUser: '' }, // 邮箱地址
        contactLanline: { data: '', enableAt: '0', focusUser: '' }, // 座机电话
        softwareDocument: { data: '', enableAt: '0', focusUser: '' }, // 软件说明文档
        includingEnglish: { data: '', enableAt: '0', focusUser: '' }, // 是否包含英文
        scoreCode: { data: '', enableAt: '0', focusUser: '' }, // 软件源代码
        cooperativeAgreement: { data: '', enableAt: '0', focusUser: '' }, // 合作开发协议
        nameExplanation: { data: '', enableAt: '0', focusUser: '' }, // 名称英文解释
        manualExplanation: { data: '', enableAt: '0', focusUser: '' } // 说明书英文解释
      },
      link: 'https://img.gongsibao.com/%E8%9C%82%E6%93%8E%E4%BA%91%E6%9C%8D%E7%89%88%E6%9D%83%E7%99%BB%E8%AE%B0%E6%9C%8D%E5%8A%A1%E5%8D%8F%E8%AE%AE.html',
      socketConnected: false,
      caseDetail: {},
      saveCaseModal: false,
      shareModal: false,
      shareUrl: '',
      caseNo: '',
      loading: false,
      token: '',
      isSave: false // 是否保存
    }
  },
  created() {
    const caseNo = this.$route.query.caseNo || this.$route.query.orderNo
    this.token = `${Date.now()}-${randomString(6)}` // socket需要的token 用来区别用户，无其他鉴权
    this.caseNo = caseNo
    this.getCaseOverview(caseNo)
    this.initSocket(caseNo)
  },
  methods: {
    initSocket(caseNo) {
      const path = process.env.VUE_APP_SOCKET_URL

      socket = io(path, { query: { token: this.token, roomId: caseNo }, transports: ['websocket'] })

      socket.on('connect', () => {
        // this.$message.success('socket 连接成功')
        this.socketConnected = true
      })

      socket.on('reconnect_error', () => {
        console.log('socket 连接错误')
      })

      socket.on('disconnect', () => {
        // this.$message.error('socket 断开连接')
        this.socketConnected = false
      })

      // 监听服务端的事件
      socket.on('init', (data) => {
        if (data) {
          this.formData = data
        } else {
          message.error({
            content: result || '案件异常！',
            duration: 2,
            onClose: () => {
              this.$router.replace(`/businessCenter/cannotEdit?caseNo=${this.caseNo}`)
            }
          })
        }
      })

      // 广播事件
      socket.on('broadcast', (broadcastData) => {
        if (typeof broadcastData === 'string') {
          broadcastData = JSON.parse(broadcastData)
        }
        // 防止串线
        if (broadcastData.unique.data === this.caseNo) {
          // enableAt = '1'的情况 不能赋值给表单
          for (const key in broadcastData) {
            if (Object.hasOwnProperty.call(broadcastData, key)) {
              const value = broadcastData[key]
              if (value.focusUser != this.token) {
                this.formData[key] = value
              }
            }
          }
        }
      })
    },
    // 获取案件基本信息
    async getCaseOverview(caseNo) {
      this.loading = true
      try {
        const res = await caseOverview(caseNo)
        this.loading = false
        this.caseDetail = res.data
      } catch (error) {
        this.loading = false
      }
    },
    // 支付
    async onPay() {
      let href = window.location.href
      let url = href.split('?')['0']
      const res = await sendPay({
        syncCallBackRedirectUrl: url,
        amount: this.caseDetail.amount,
        outAccountId: this.$store.getters.userInfo.orgList[0].accountId,
        operatorId: this.$store.getters.userInfo.userId,
        orderNo: this.caseDetail.caseNo,
        tranContent: '版权工作台案件支付'
      })
      if (res.code == 0) {
        window.open(res.data.url, '_self')
      }
    },
    // 提交案件
    async onSubmit() {
      this.isSave = true
      const caseDetail = this.caseDetail
      const reqData = {
        caseDetailId: caseDetail.caseDetailId,
        caseNo: caseDetail.caseNo,
        childState: caseDetail.childState,
        state: caseDetail.state,
        token: this.token,
        ...this.formData
      }
      this.loading = true
      const res = await submitCase(reqData).catch((err) => {
        this.loading = false
      })
      this.loading = false
      this.saveCaseModal = false
      if (res.code == 0) {
        this.$message.success('案件已提交成功、请等待平台审核。')
        this.$router.push('/businessCenter/caseManage')
      }
    },
    // 保存案件
    async saveCase(flag) {
      this.isSave = true
      const caseDetail = this.caseDetail
      const reqData = {
        caseDetailId: caseDetail.caseDetailId,
        caseNo: caseDetail.caseNo,
        childState: caseDetail.childState,
        state: caseDetail.state,
        token: this.token,
        ...this.formData
      }
      this.loading = true
      const res = await saveCase(reqData).catch((err) => {
        this.loading = false
      })
      this.loading = false
      if (res.code == 0) {
        if (flag && this.caseDetail.transState === 1) {
          this.saveCaseModal = true
        } else {
          this.$message.success('案件信息保存成功')
        }
      }
    },
    onShare() {
      this.shareUrl = location.origin + '/detailShare?caseNo=' + this.caseNo
      this.shareModal = true
    },
    // 复制成功
    copySuccess() {
      this.$message.success('复制成功')
      this.shareModal = false
    },

    // 针对非输入框表单类型 同步数据
    onDataChange(data) {
      const target = data.target
      // 以下三个字段是引用类型，需要序列化后传给后端，同时要同步本地formData中的数据
      if (target == 'firstPublishAddress' || target == 'postalAddress' || target == 'authors') {
        this.formData[target]['data'] = JSON.stringify(data.data)
      }
      this.socketConnected && socket.emit('syncData', JSON.stringify(data))
    },
    onFocus(key) {
      // 约定：输入框触发聚焦事件，通知后台禁用当前输入框
      this.socketConnected && socket.emit('disable', key)
    },
    // 启用按钮
    enable(key) {
      this.socketConnected && socket.emit('enable', key)
    },
    // 针对 输入框类型 同步数据
    onBlur(key) {
      // 约定：输入框触发失焦事件，想后台同步数据。
      let syncData = {
        target: key,
        data: this.getFormDataByKey(key)
      }
      this.socketConnected && socket.emit('syncData', JSON.stringify(syncData))
    },
    getFormDataByKey(key) {
      return this.formData[key]['data'] || ''
    },
    // 判断案件状态
    getChildState(state) {
      switch (state) {
        case 10:
          return '待付款'
        case 20:
          return '待补充信息'
        case 30:
          return '待平台审核'
        case 31:
          return '平台审核未通过'
        case 32:
          return '待客户确认表'
        case 33:
          return '确认表有误'
        case 34:
          return '业务待处理'
        case 35:
          return '材料待邮寄'
        case -30:
          return '待退款'
        case 40:
          return '已递交官方'
        case 41:
          return '下发补正通知书'
        case 42:
          return '已下证'
        case 43:
          return '已完成'
        case -40:
          return '已退款'
        default:
          break
      }
    },
    // 支付方式
    getPaidMethod(type) {
      switch (type) {
        case 'wechat_qr':
          return '微信支付'
        case 'alipay_qr':
          return '支付宝支付'
        case 'gateway_pub':
          return '网银支付_对公'
        case 'gateway_pri':
          return '网银支付_对私'
        case 'balance_pay':
          return '余额支付'
        case 'init_sync':
          return '期初同步'
        default:
          break
      }
    }
  },
  beforeDestroy() {
    if (socket) socket.disconnect()
  },
  beforeRouteLeave(to, form, next) {
    let _this = this
    if (!this.isSave) {
      this.$confirm({
        title: '温馨提示',
        content: '是否保存信息？',
        onOk() {
          _this.saveCase()
        },
        onCancel() {
          next()
        }
      })
      return
    }
    next()
  },
  components: {
    BaseForm
  }
}
</script>

<style lang="less" scoped>
.container {
  position: relative;
  min-width: 1200px;
  height: 100%;
  overflow-y: auto;
  background: #fff;
  padding: 20px 20px 80px;
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 30px;
    .title {
      font-weight: 500;
      color: #333;
    }
  }
  .material {
    color: #333;
    margin-bottom: 10px;
  }
  .card-info {
    width: 100%;
    height: 190px;
    border: 1px solid #f0f0f0;
    margin-bottom: 20px;
    .head {
      height: 40px;
      background: #fafafa;
      padding: 0 10px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 14px;
      font-weight: 400;
      color: #666;
      line-height: 14px;
      .head-left {
        position: relative;
        height: 100%;
        line-height: 40px;
        cursor: pointer;
        .time {
          color: #999;
        }
      }
      .head-right {
        position: relative;
        height: 100%;
        line-height: 40px;
        cursor: pointer;
      }
    }
    .content {
      display: flex;
      height: 150px;

      .left {
        flex-basis: 400px;
        box-sizing: border-box;
        margin: 15px;
        border-right: 1px solid #f0f0f0;
        p {
          height: 28px;
          line-height: 28px;
        }
        .moneyState {
          display: inline-block;
          width: 56px;
          height: 22px;
          line-height: 22px;
          text-align: center;
          color: #47ba97;
          background: rgba(71, 186, 151, 0.1);
          border-radius: 2px;
          &.warn {
            color: #ff5500;
            background: rgba(255, 85, 0, 0.1);
          }
        }
        .tip {
          font-size: 20px;
          color: #eeaa00;
          line-height: 32px;
          font-weight: bold;
          line-height: 28px;
        }
      }
      .right {
        flex: 1;
        overflow-y: auto;
        box-sizing: border-box;
        margin: 15px 15px 15px 0;

        .item {
          width: 162px;
          height: 20px;
          text-align: center;
          font-size: 14px;
          line-height: 20px;
          border-radius: 10px;
          background: #f0efef;
          color: #999;
          &.active {
            background: @theme-color;
            color: #fff;
          }
        }

        .fun-list {
          .fun-item {
            display: flex;
            align-items: center;
            margin-bottom: 10px;
            .dot {
              width: 4px;
              height: 4px;
              border-radius: 50%;
              background: @theme-color;
              margin-right: 10px;
              flex-shrink: 0;
            }
            .time {
              font-size: 14px;
              font-weight: 400;
              color: #aaaaaa;
              line-height: 14px;
              margin-right: 40px;
              flex-shrink: 0;
            }
            .desc {
              color: #666;
              line-height: 20px;
            }
          }
        }
      }
    }
  }
}
/deep/ .ant-modal-footer {
  border: none;
  margin-top: 20px;
  padding-bottom: 20px;
}
.share-modal-content {
  .case-no {
    height: 14px;
    font-size: 14px;
    font-weight: 400;
    color: #333333;
    line-height: 14px;
  }
  .case-desc {
    height: 14px;
    font-size: 14px;
    font-weight: 400;
    color: #999999;
    line-height: 14px;
    margin-top: 14px;
  }
  .case-url {
    display: flex;
    align-items: center;
    margin-top: 20px;
    .url {
      width: 304px;
      height: 40px;
      background: @item-selected;
      border-radius: 2px;
      line-height: 40px;
      padding: 0 10px;
      margin-right: 10px;
    }
    .btn {
      height: 40px;
      flex: 1;
    }
  }
  .footer {
    margin-top: 20px;
    text-align: right;
  }
}
</style>
